import { BotInfo, BrowserInfo, NodeInfo } from 'detect-browser';
import { ClientPricingAction, PricingType } from '../types';
import {
    DraperyItemDetailsFields,
    DraperyItemDetailsFieldsAction,
    PricingGroupItem,
    PricingSimpleItem,
} from "../../../redux/modules/my-shop/drapery-item-details-fields-reducer";
import {
    FormInput,
    SectionTitle,
    TooltipContainer,
    TooltipPopup,
    TooltipText,
} from "../styles";
import React, { ChangeEvent, Dispatch, FC, useEffect, useRef, useState } from "react";
import { checkIfGroupItem, validatePricingInput } from "../helpers";
import { draperyPricingTypes, draperyWidthRoundUpTypes } from "../constants";
import PricingGroupGrid from "../pricing-group-grid";
import SelectList from "../../UI/select-list";
import TooltipSpecialtyFabricHandlingChecked from "../../../assets/images/specialty-fabric-handling-checked.png";
import AddButtonE from "../../UI/buttons/add-button";
import styled from "styled-components";
import PleatModal from "../pleat-modal/pleat-modal";
import { FormFields } from "../../../redux/modules/my-shop/form-fields-reducer";
import Checkbox from "../../../ui_components/checkbox/checkbox";

import { NewAddOn, NewAddOnError } from './main';
import { ErrorInputPopUp } from '../../input_popups/error_input_popup';
interface PricingProps {
  browser: BrowserInfo | BotInfo | NodeInfo | null;
  draperyItemDetailsFields: DraperyItemDetailsFields;
  dispatch: Dispatch<DraperyItemDetailsFieldsAction>;
  itemId: number | null;
  formFields: FormFields;
  highLightInput?: string[];
  openNewAddOn?: boolean;
  newAddOn?: NewAddOn;
  newAddOnError?: NewAddOnError;
  handleOpenNewAddOn?(val: boolean): void;
  handleCreateNewAddOn?(): void;
  handleCancelNewAddOn?(): void;
  handleNewAddOnForm?(e: React.ChangeEvent<HTMLInputElement>): void;
}

const AddButton = styled(AddButtonE)`
  margin: 12px auto 0px 10px;
  font-size: 15px;
  border-radius: 8px;
  z-index: 10;
`;

const Pricing: FC<PricingProps> = ({
  browser,
  draperyItemDetailsFields,
  dispatch,
  itemId,
  formFields,
  highLightInput,
  openNewAddOn,
  newAddOn,
  newAddOnError,
  handleOpenNewAddOn,
  handleCreateNewAddOn,
  handleCancelNewAddOn,
  handleNewAddOnForm,
}) => {
  const {
    pricingTypeName,
    isClientPricingActionOn,
    clientPricingAction,
    clientPricingValue,
    isPartialWidthRoundingOn,
    partialWidthRoundUpTypeName,
    pleatTypesWithPricing,
    liningAndInterliningWithPricing,
    cafeCurtainsWidthInches,
    cafeCurtainsWidthPricing,
    extraLargePanelsLengthInches,
    extraLargePanelsLengthPricing,
    extraLargePanelsWidthInches,
    extraLargePanelsWidthPricing,
    draperyPinningWidthPricing,
    specialityFabricsMarkUpPercentage,
    embellishmentsWithPricing,
    addOnsWithPricing,
    patternMatchingUpcharges,
  } = draperyItemDetailsFields;

  const newAddOnNameRef = useRef(null);
  const newAddOnPriceRef = useRef(null);

  const [isPleatModalOpen, setIsPleatModalOpen] = useState(false);

  const autoCompleteOffSetting = browser && browser.name === 'chrome' ? 'new-password' : 'off';

  const partialWidthRoundUpGridHeaders = [
    {
      title: 'HEADER / PLEAT TYPE',
    },
    {
      title: `Base ${pricingTypeName} price`.toUpperCase(),
      subTitle: 'unlined, per width',
    },
  ];

  const liningAndInterliningHeaders = [
    {
      title: 'LINING & INTERLINING',
    },
    {
      title: 'ADDITIONAL LABOR PRICE',
      subTitle: 'per width',
    },
  ];

  const addOnsHeaders = [
    {
      title: 'TYPE',
    },
    {
      title: `PRICE`,
      subTitle: 'per width',
    },
  ];

  const patternMatchingUpchargesHeaders = [
    {
      title: 'TYPE',
    },
    {
      title: 'PRICE',
      subTitle: 'per width',
    },
  ];

  const embellishmentsPricingHeaders = [
    {
      title: 'TYPE',
    },
    {
      title: 'PRICE',
      subTitle: 'per applied foot',
    },
  ];
  const formInputStyleClass = 'px-1.5 py-2 ml-2 max-w-[80px] for-pricing-tab';

  const [clientType, setClientType] = useState<string>('');

  const getClientType = () => {
    if (!pricingTypeName || !pricingTypeName.length) {
      return '';
    }
    return pricingTypeName === PricingType.Retail ? PricingType.Trade : PricingType.Retail;
  };

  const handlePricingTypeChange = (value: string | number, name: string): void => {
    const targetValue = value as string | number | boolean;
    let updates = {
      [name]: targetValue,
    };
    const selectedItem = draperyPricingTypes.find((pt) => pt.key === targetValue);
    const pricingTypeName = selectedItem ? selectedItem.label : '';

    updates = {
      ...updates,
      pricingTypeName,
    };

    if (pricingTypeName && pricingTypeName.length) {
      const clientPricingAction =
        pricingTypeName === PricingType.Retail
          ? ClientPricingAction.Discount
          : ClientPricingAction.MarkUp;
      updates.clientPricingAction = clientPricingAction;
    } else {
      setClientType('');
      updates.clientPricingAction = '';
      updates.clientPricingValue = '';
      updates.isClientPricingActionOn = true;
    }

    dispatch({
      type: 'updateFormFields',
      formFieldUpdates: updates,
    });
  };

  const handlePartialWidthRoundUpChange = (value: string | number, name: string): void => {
    const targetValue = value as string | number | boolean;
    let updates = {
      [name]: targetValue,
    };

    const selectedItem = draperyWidthRoundUpTypes.find((pt) => pt.key === targetValue);
    const selectedValue = selectedItem ? selectedItem.label : '';

    updates = {
      ...updates,
      partialWidthRoundUpTypeName: selectedValue,
    };

    dispatch({
      type: 'updateFormFields',
      formFieldUpdates: updates,
    });
  };

  const toggleCheckbox = (e: ChangeEvent<HTMLInputElement>) => {
    const fieldName = e.currentTarget.name;
    const value = !draperyItemDetailsFields[fieldName];

    dispatch({
      type: 'updateFormFields',
      formFieldUpdates: {
        [fieldName]: value,
      },
    });
  };

  const handleDeleteRow = (item: any) => {
    const arr = [...draperyItemDetailsFields['addOnsWithPricing']];
    const filtered_arr = arr && arr.length > 0 ? arr.filter((i) => i.id !== item.id) : [];

    dispatch({
      type: 'updateFormFields',
      formFieldUpdates: {
        addOnsWithPricing: filtered_arr,
      },
    });
  };

  const handlePricingInputChange = (
    e: ChangeEvent<HTMLInputElement>,
    keyParam?: string,
    type: string = 'dollarAmount'
  ) => {
    let value = e.target.value;

    const numericValue = parseFloat(value);

    if (isNaN(numericValue) || (value.length === 1 && value[0] === '.')) {
      value = '';
    }

    if (value === '00') {
      value = '';
    }

    if (value.startsWith('0') && value.length > 1) {
      value = `0.${value.slice(1)}`;
    }

    value = value.replace(/[^\d.]/g, '');

    value = value.replace(/\.{2,}/g, '.');

    const firstDotIndex = value.indexOf('.');
    if (firstDotIndex !== -1) {
      value = `${value.slice(0, firstDotIndex + 1)}${value
        .slice(firstDotIndex + 1)
        .replace(/\./g, '')}`;
    }

    const decimalParts = value.split('.');
    if (decimalParts.length > 1) {
      value = `${decimalParts[0].slice(0, 3)}.${decimalParts[1].slice(0, 2)}`;
    } else {
      value = value.slice(0, 3);
    }

    const keyboardEvent = e.nativeEvent as any;
    const isBackspaceAction = keyboardEvent.inputType === 'deleteContentForward';

    if (isBackspaceAction && value === '0' && numericValue === 0) {
      value = '';
    }

    dispatch({
      type: 'updateFormFields',
      formFieldUpdates: {
        [keyParam || type]: value,
      },
    });
  };

  const handlePricingGridsInputsChange = ({
    e,
    gridName,
    type = 'dollarAmount',
    keyParam,
  }: {
    e: ChangeEvent<HTMLInputElement>;
    gridName: string;
    type?: string;
    keyParam?: string;
  }) => {
    const inputId = e.currentTarget.id;
    const updates = validatePricingInput({
      event: e,
      keyParam,
      type,
    });
    if (inputId === 'draperyPinning') {
      const keyParam = 'draperyPinningWidthPricing';
      const type = 'text';
      handlePricingInputChange(e, keyParam, type);
    }
    let pricingInputGrid = draperyItemDetailsFields[gridName].map(
      (item: PricingSimpleItem | PricingGroupItem) => {
        let itemTyped;
        const isGroupItem = checkIfGroupItem(item);
        if (isGroupItem) {
          itemTyped = item as PricingGroupItem;
          const { items } = itemTyped.group;
          const itemsUpdated = items.map((i) => {
            const { id } = i;
            if (id === inputId) {
              let roundedValue = parseFloat(updates[inputId]);

              if (isNaN(roundedValue)) {
                roundedValue = 0;
              }

              if (
                updates[inputId].startsWith('0') &&
                updates[inputId].length > 1 &&
                !updates[inputId].includes('.')
              ) {
                updates[inputId] = '0';
              }

              return { ...i, price: updates[inputId] };
            }
            return i;
          });
          itemTyped.group.items = itemsUpdated;
          return itemTyped;
        }

        itemTyped = item as PricingSimpleItem;
        const { id } = itemTyped;
        if (id === inputId) {
          let roundedValue = parseFloat(updates[inputId]);

          if (isNaN(roundedValue)) {
            roundedValue = 0;
          }

          if (
            updates[inputId].startsWith('0') &&
            updates[inputId].length > 1 &&
            !updates[inputId].includes('.')
          ) {
            updates[inputId] = '0';
          }

          return { ...itemTyped, price: updates[inputId] };
        }
        return itemTyped;
      }
    );

    const keyboardEvent = e.nativeEvent as any;
    const isDeleteAction = keyboardEvent.inputType === 'deleteContentBackward';
    const isBackspaceAction = keyboardEvent.inputType === 'deleteContentForward';

    if (
      (isDeleteAction || isBackspaceAction) &&
      updates[inputId] === '0' &&
      updates[inputId] !== e.currentTarget.value
    ) {
      updates[inputId] = '';
    }

    const decimalParts = updates[inputId].split('.');
    if (decimalParts.length > 1) {
      updates[inputId] = `${decimalParts[0].slice(0, 3)}.${decimalParts[1].slice(0, 2)}`;
    } else {
      updates[inputId] = updates[inputId].slice(0, 3);
    }

    dispatch({
      type: 'updateFormFields',
      formFieldUpdates: {
        [gridName]: pricingInputGrid,
      },
    });
  };

  useEffect(() => {
    const clientTypeVal = getClientType();
    setClientType(clientTypeVal);
  }, [pricingTypeName]);

  const openPleatModal = (event: { preventDefault: () => void }) => {
    event.preventDefault();
    setIsPleatModalOpen(true);
  };

  const closePleatModal = () => {
    setIsPleatModalOpen(false);
  };

  const updatedPricingRows = [
    {
      id: 'draperyPinning',
      name: 'Drapery Pinning',
      price: draperyPinningWidthPricing,
    },
    ...(addOnsWithPricing ? addOnsWithPricing : []),
  ];

  return (
    <div
      className="flex flex-wrap w-full items-start"
      style={{ maxWidth: '1280px', fontSize: '16px', marginTop: '4px', marginInline: 'auto' }}
    >
      <div className="lg:w-full mb-6 ">
        <div className="flex flex-col mb-2">
          <div>
            <SectionTitle className="pricingRedesign">SETUP</SectionTitle>
            <div className="flex flex-row items-center mt-3">
              <span className="mr-2 font-normal">These are</span>
              <SelectList
                name="pricingTypeId"
                flexDirection="column"
                required
                noAddButton
                valueSelect={pricingTypeName}
                handleClickSelect={handlePricingTypeChange}
                className="w-[100px]"
                selectList={draperyPricingTypes}
                noClearBox
                uiDropArrow
                pricingRedesign
              />
              <span className="ml-2">prices</span>
            </div>
            {pricingTypeName && !!pricingTypeName.length && (
              <div className="mt-4">
                <Checkbox
                  name="isClientPricingActionOn"
                  checked={isClientPricingActionOn}
                  onChange={toggleCheckbox}
                  pricingRedesign
                />
                <span>{clientPricingAction} these prices</span>
                &nbsp;
                <FormInput
                  id="clientPricingValue"
                  name="Client Pricing Value"
                  className={formInputStyleClass}
                  type="text"
                  value={clientPricingValue}
                  placeholder="20.00"
                  onChange={(e) => handlePricingInputChange(e, 'clientPricingValue', 'percentage')}
                  uiReportOnBlur={false}
                  disabled={!isClientPricingActionOn}
                  uiDisabled={!isClientPricingActionOn}
                  required={isClientPricingActionOn}
                  autoComplete={autoCompleteOffSetting}
                  list="autocompleteOff"
                  darkBorder
                />
                <span className="ml-2">{`% for my ${clientType}`} clients</span>
              </div>
            )}
          </div>
          <div className="mt-[24px]">
            <SectionTitle className="pricingRedesign">DRAPERY FABRICATION</SectionTitle>
            <div className="flex flex-col">
              <div className="flex flex-row items-center">
                <Checkbox
                  name="isPartialWidthRoundingOn"
                  checked={isPartialWidthRoundingOn}
                  onChange={toggleCheckbox}
                  pricingRedesign
                />
                <span className="mr-2">Round partial widths up to the nearest&nbsp;</span>
                <SelectList
                  name="partialWidthRoundUpTypeId"
                  flexDirection="column"
                  required={isPartialWidthRoundingOn}
                  noAddButton
                  valueSelect={partialWidthRoundUpTypeName}
                  handleClickSelect={handlePartialWidthRoundUpChange}
                  className="max-w-[100px]"
                  selectList={draperyWidthRoundUpTypes}
                  noClearBox
                  pricingRedesign
                  uiDropArrow
                />
                <span className="ml-2">width for Pricing</span>
              </div>
              <div className="mt-[24px]">
                <PricingGroupGrid
                  headers={partialWidthRoundUpGridHeaders}
                  rows={pleatTypesWithPricing}
                  handleInputChange={(e) =>
                    handlePricingGridsInputsChange({
                      e,
                      gridName: 'pleatTypesWithPricing',
                    })
                  }
                  formFields={formFields}
                  draperyItemDetailsFields={draperyItemDetailsFields}
                  itemId={itemId}
                  highLightInput={highLightInput}
                />
              </div>

              <AddButton title="Add New Pleat" onClick={openPleatModal} pricingRedesign />
              <div className="mt-[24px]">
                <PricingGroupGrid
                  headers={liningAndInterliningHeaders}
                  rows={liningAndInterliningWithPricing}
                  handleInputChange={(e) =>
                    handlePricingGridsInputsChange({
                      e,
                      gridName: 'liningAndInterliningWithPricing',
                    })
                  }
                />
              </div>
            </div>
          </div>

          <div className="mb-2 mt-[24px]">
            <SectionTitle className="pricingRedesign">PATTERN MATCHING UPCHARGES</SectionTitle>
          </div>

          <PricingGroupGrid
            headers={patternMatchingUpchargesHeaders}
            rows={patternMatchingUpcharges}
            handleInputChange={(e) =>
              handlePricingGridsInputsChange({
                e,
                gridName: 'patternMatchingUpcharges',
              })
            }
            highLightInput={highLightInput}
          />

          <div className="mt-[24px]">
            <SectionTitle className="pricingRedesign">CAFE CURTAINS</SectionTitle>
            <div className="flex flex-row items-center">
              <span>For finished lengths under</span>&nbsp;
              <FormInput
                id="cafeCurtainsWidthInches"
                name="cafeCurtainsWidthInches"
                className={formInputStyleClass}
                type="text"
                value={cafeCurtainsWidthInches}
                onChange={(e) => handlePricingInputChange(e, 'cafeCurtainsWidthInches')}
                uiReportOnBlur={false}
                disabled={false}
                required={true}
                uiDisabled={false}
                autoComplete={autoCompleteOffSetting}
                list="autocompleteOff"
                placeholder="36"
                darkBorder
              />
              <span className="ml-2">”, subtract $</span>{' '}
              <FormInput
                id="cafeCurtainsWidthPricing"
                name="cafeCurtainsWidthPricing"
                className={formInputStyleClass}
                type="text"
                value={cafeCurtainsWidthPricing}
                onChange={(e) => handlePricingInputChange(e, 'cafeCurtainsWidthPricing')}
                uiReportOnBlur={false}
                disabled={false}
                required={true}
                uiDisabled={false}
                autoComplete={autoCompleteOffSetting}
                list="autocompleteOff"
                placeholder="10.00"
                darkBorder
              />
              &nbsp;
              <span className="ml-2">/width</span>
            </div>
          </div>
          <div className="mt-[24px]">
            <SectionTitle className="pricingRedesign">EXTRA LARGE PANELS</SectionTitle>
            <div className="flex flex-col">
              <div className="flex flex-row items-center mb-3">
                <span>For finished lengths over</span>&nbsp;
                <FormInput
                  id="extraLargePanelsLengthInches"
                  name="extraLargePanelsLengthInches"
                  className={formInputStyleClass}
                  type="text"
                  value={extraLargePanelsLengthInches}
                  onChange={(e) => handlePricingInputChange(e, 'extraLargePanelsLengthInches')}
                  uiReportOnBlur={false}
                  disabled={false}
                  required={true}
                  uiDisabled={false}
                  autoComplete={autoCompleteOffSetting}
                  list="autocompleteOff"
                  placeholder="108"
                  darkBorder
                />
                <span className="ml-2">inches, add $</span>
                &nbsp;
                <FormInput
                  id="extraLargePanelsLengthPricing"
                  name="Client Pricing Value"
                  className={formInputStyleClass}
                  type="text"
                  value={extraLargePanelsLengthPricing}
                  onChange={(e) => handlePricingInputChange(e, 'extraLargePanelsLengthPricing')}
                  uiReportOnBlur={false}
                  disabled={false}
                  required={true}
                  uiDisabled={false}
                  autoComplete={autoCompleteOffSetting}
                  list="autocompleteOff"
                  placeholder="5.00"
                  darkBorder
                />
                &nbsp;
                <span className="ml-2">/additional foot per width</span>
              </div>
              <div className="flex flex-row items-center">
                <span>For finished widths over</span>&nbsp;
                <FormInput
                  id="extraLargePanelsWidthInches"
                  name="extraLargePanelsWidthInches"
                  className={formInputStyleClass}
                  type="text"
                  value={extraLargePanelsWidthInches}
                  onChange={(e) => handlePricingInputChange(e, 'extraLargePanelsWidthInches')}
                  uiReportOnBlur={false}
                  disabled={false}
                  required
                  uiDisabled={false}
                  autoComplete={autoCompleteOffSetting}
                  list="autocompleteOff"
                  placeholder="2"
                  darkBorder
                />
                <span className="ml-2">, add $</span>
                &nbsp;
                <FormInput
                  id="extraLargePanelsWidthPricing"
                  name="extraLargePanelsWidthPricing"
                  className={formInputStyleClass}
                  type="text"
                  value={extraLargePanelsWidthPricing}
                  onChange={(e) => handlePricingInputChange(e, 'extraLargePanelsWidthPricing')}
                  uiReportOnBlur={false}
                  disabled={false}
                  required
                  uiDisabled={false}
                  autoComplete={autoCompleteOffSetting}
                  list="autocompleteOff"
                  placeholder="10.00"
                  darkBorder
                />
                &nbsp;
                <span className="ml-2">/each width</span>
              </div>
            </div>
          </div>
          {/* <div className="mt-[24px]">
                        <SectionTitle className="pricingRedesign">DRAPERY PINNING</SectionTitle>
                        <div className="flex flex-row items-center">
                            <span>Add $</span>&nbsp;
                            <FormInput
                                id="draperyPinningWidthPricing"
                                name="draperyPinningWidthPricing"
                                className={formInputStyleClass}
                                type="text"
                                value={draperyPinningWidthPricing}
                                onChange={(e) =>
                                    handlePricingInputChange(
                                        e,
                                        "draperyPinningWidthPricing"
                                    )
                                }
                                uiReportOnBlur={false}
                                disabled={false}
                                required={true}
                                uiDisabled={false}
                                autoComplete={autoCompleteOffSetting}
                                list="autocompleteOff"
                            />
                            &nbsp;
                            <span>/width</span>
                        </div>
                    </div> */}
          <div className="mt-[24px]">
            <div className="flex flex-row items-center" style={{ marginBottom: '12px' }}>
              <SectionTitle>SPECIALTY FABRICS</SectionTitle>
              <TooltipPopup
                text={
                  <TooltipContainer>
                    <TooltipText>
                      <div>
                        <p className="leading-6 m-0">
                          This mark-up is applied to the total fabrication price when the
                        </p>
                        <div className="float-left mr-[8px]">
                          <img
                            src={TooltipSpecialtyFabricHandlingChecked}
                            alt="Image"
                            className="border max-h-[22px]"
                          />
                        </div>
                        <p className="leading-6 m-0">
                          option is selected for a fabric on a order. If more than one fabric
                          requires special handling on an order, the mark-up will only be applied
                          once.
                        </p>
                      </div>
                    </TooltipText>
                  </TooltipContainer>
                }
                position="bottom left"
                className="normal"
                closeOnClick
              />
            </div>

            <div className="flex flex-row items-center">
              <span>Mark-up total fabrication price for items using specialty fabrics</span>
              &nbsp;
              <FormInput
                id="specialityFabricsMarkUpPercentage"
                name="specialityFabricsMarkUpPercentage"
                className={formInputStyleClass}
                type="text"
                value={specialityFabricsMarkUpPercentage}
                onChange={(e) =>
                  handlePricingInputChange(e, 'specialityFabricsMarkUpPercentage', 'percentage')
                }
                uiReportOnBlur={false}
                disabled={false}
                required={true}
                uiDisabled={false}
                autoComplete={autoCompleteOffSetting}
                list="autocompleteOff"
                placeholder="20"
                darkBorder
              />
              &nbsp;
              <span>%</span>
            </div>
          </div>

          <div className="mt-[24px]">
            <div className="flex flex-row items-center" style={{ marginBottom: '12px' }}>
              <SectionTitle>EMBELLISHMENTS</SectionTitle>
              <TooltipPopup
                text={
                  <TooltipContainer>
                    <TooltipText>
                      <b>BANDING:</b>
                      &nbsp;Fabric (usually a contrast fabric) seamed to the main fabric around the
                      border or inset within the drapery.
                      <br />
                      <br />
                      <b>CORDING:</b>
                      &nbsp;Rope that is sewn into a seam or edge. This can be a pre-made decorative
                      cording or welt cording (non-decorative cording covered with fabric).
                      <br />
                      <br />
                      <b>FLANGE:</b>&nbsp;A strip of fabric that is folded in half and sewn into the
                      seam or edge of the drapery.
                      <br />
                      <br />
                      <b>TRIM:</b>&nbsp;Strips of fabric or pre-made trim applied on top of the main
                      fabric.
                      <br />
                      <br />
                    </TooltipText>
                  </TooltipContainer>
                }
                position="bottom left"
                className="normal"
                closeOnClick
              />
            </div>

            <div>
              <PricingGroupGrid
                headers={embellishmentsPricingHeaders}
                rows={embellishmentsWithPricing}
                handleInputChange={(e) =>
                  handlePricingGridsInputsChange({
                    e,
                    gridName: 'embellishmentsWithPricing',
                  })
                }
              />
            </div>
          </div>

          <div className="mt-[24px]">
            <div className="mb-2">
              <SectionTitle className="pricingRedesign">ADD-ONS</SectionTitle>
            </div>
            <PricingGroupGrid
              headers={addOnsHeaders}
              rows={updatedPricingRows}
              handleInputChange={(e) =>
                handlePricingGridsInputsChange({
                  e,
                  gridName: 'addOnsWithPricing',
                })
              }
              highLightInput={highLightInput}
              deleteRow={false}
              onDeleteRow={handleDeleteRow}
            />

            <div className="add_new_add_on_wrapper">
              {!openNewAddOn ? (
                <div className="button_wrapper">
                  <button
                    onClick={() => {
                      if (handleOpenNewAddOn) handleOpenNewAddOn(true);
                    }}
                    className="button"
                    type="button"
                  >
                    + Add Other
                  </button>
                </div>
              ) : (
                <div className="new_row_wrapper">
                  <div className="new_row_insert_wrapper">
                    <div className="input_wrapper relative">
                      <ErrorInputPopUp
                        anchorRef={newAddOnNameRef}
                        active={
                          (newAddOnError && newAddOnError.name && newAddOnError.name.active) ||
                          false
                        }
                        message={
                          (newAddOnError && newAddOnError.name && newAddOnError.name.message) ||
                          'Check this field'
                        }
                      />

                      <input
                        ref={newAddOnNameRef}
                        onChange={(e) => {
                          if (handleNewAddOnForm) handleNewAddOnForm(e);
                        }}
                        name="name"
                        value={(newAddOn && newAddOn.name) || ''}
                        className={`input ${
                          newAddOnError && newAddOnError.name && newAddOnError.name.active
                            ? 'error bg_error'
                            : ''
                        }`}
                        type="text"
                        placeholder="Enter name..."
                      />
                    </div>

                    <div className="price_wrapper_container">
                      <div className="price_wrapper relative">
                        <ErrorInputPopUp
                          anchorRef={newAddOnPriceRef}
                          active={
                            (newAddOnError && newAddOnError.price && newAddOnError.price.active) ||
                            false
                          }
                          message={
                            (newAddOnError && newAddOnError.price && newAddOnError.price.message) ||
                            'Check this field'
                          }
                        />

                        <span>$</span>
                        <div className="price_wrapper_input_container">
                          <input
                            ref={newAddOnPriceRef}
                            onChange={(e) => {
                              if (handleNewAddOnForm) handleNewAddOnForm(e);
                            }}
                            name="price"
                            value={(newAddOn && newAddOn.price) || ''}
                            className={`input ${
                              newAddOnError && newAddOnError.price && newAddOnError.price.active
                                ? 'error bg_error'
                                : ''
                            }`}
                            type="text"
                            placeholder="0.00"
                          />
                        </div>
                      </div>
                    </div>

                    <div style={{width: '48px'}} className="inline-flex" />
                  </div>

                  <div className="new_row_actions_wrapper">
                    <div>
                      <button
                        className="cancel_btn_white"
                        onClick={() => {
                          if (handleCancelNewAddOn) handleCancelNewAddOn();
                        }}
                        type="button"
                      >
                        Cancel
                      </button>
                    </div>

                    <div>
                      <button
                        className="primary_btn"
                        onClick={() => {
                          if (handleCreateNewAddOn) handleCreateNewAddOn();
                        }}
                        type="button"
                      >
                        Add
                      </button>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      {isPleatModalOpen && (
        <PleatModal
          isPleatModalOpen={isPleatModalOpen}
          onPleatModalClose={closePleatModal}
          dispatch={dispatch}
          formFields={formFields}
          draperyItemDetailsFields={draperyItemDetailsFields}
          itemId={itemId}
        />
      )}
    </div>
  );
};

export default Pricing;
